import { CitylinkSensor } from 'src/app/public-utility/sensors/models/citylink-sensor';
import { PaginationOutputDto } from 'src/app/_shared/dtos/pagination.output.dto';

export class PaginatedCitylinkSensor {
  pagination: PaginationOutputDto;
  data: CitylinkSensor[];
}
